import wixLocation from 'wix-location';

$w.onReady(function () {
	// Write your code here
	// let user_id = local.getItem("user_id")
	// wixData.query("RecipeOrderDetail").eq("user_id", user_id).find().then((order_results) => {
    //            if (order_results.items.length === 0) {
    //                let first_order = true;
	// 			   $w('#discountStrip').expand();
	// 		   }
	// 		   else{
	// 			   $w('#discountStrip').collapse();}})
    //$w("#couponcode").collapse();
});


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text504_click(event) {
	wixLocation.to("/fresh-frozen"); 
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text503_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	wixLocation.to("/treats");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text498_click(event) {
	wixLocation.to("/our-process");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text497_click(event) {
	wixLocation.to("/how-it-works");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text496_click(event) {
	wixLocation.to("/plans-and-programs");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text495_click(event) {
	wixLocation.to("/recipes"); 
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text493_click(event) {
	wixLocation.to("/connect");
}


/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text492_click(event) {
	wixLocation.to("/blogs");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text491_click(event) {
	wixLocation.to("/shop");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text490_click(event) {
	wixLocation.to("/about-us");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text488_click(event) {
	wixLocation.to("/faqs");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text487_click(event) {
	wixLocation.to("/connect");
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function text486_click(event) {
	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
	// Add your code for this event here: 
	wixLocation.to("/connect");
}

